var map = {
	"./incubators.candled-rack-eggs.js": "./src/router/admin/incubators.candled-rack-eggs.js",
	"./incubators.duck-egg-collections.js": "./src/router/admin/incubators.duck-egg-collections.js",
	"./incubators.rack-eggs.js": "./src/router/admin/incubators.rack-eggs.js",
	"./incubators.temperature-monitoring.js": "./src/router/admin/incubators.temperature-monitoring.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/router/admin sync incubators(?!\\.route)\\.[a-z-]+(\\.js$)";